// extracted by mini-css-extract-plugin
export default {"followContainer":"index_followContainer__n0Y8V","favorite":"index_favorite__EGT08","followIcon":"index_followIcon__2Opcf"};